// EditableTable.tsx
import React, { useState } from "react";
import {
  Table,
  Form,
  Input,
  Typography,
  Popconfirm,
  Progress,
  Button,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import { FILE_UPLOAD_CONFIG } from "./FileMessageRouteConfig";
const { Text } = Typography;
interface FileData {
  key: string;
  fileName: string;
  format: string;
  fileSize: number;
  artist: string;
  track: string;
  notes: string;
  progress: number;
}

interface EditableTableProps {
  fileList: FileData[];
  setFileList: React.Dispatch<React.SetStateAction<FileData[]>>;
  form: any;
}

const EditableTable: React.FC<EditableTableProps> = ({
  fileList,
  setFileList,
  form,
}) => {
  const [editingKey, setEditingKey] = useState("");

  const isEditing = (record: FileData) => record.key === editingKey;

  const edit = (record: Partial<FileData> & { key: React.Key }) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.key);
  };

  const save = async (key: React.Key) => {
    try {
      const row = (await form.validateFields()) as FileData;
      const newData = [...fileList];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setFileList(newData);

        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const cancel = () => {
    setEditingKey("");
  };

  // Your column definitions remain the same
  const columns = [
    { title: "File Name", dataIndex: "fileName", key: "fileName" },
    { title: "Format", dataIndex: "format", key: "format" },
    {
      title: "File Size",
      dataIndex: "fileSize",
      key: "fileSize",
      render: (size: number) => `${(size / 1024).toFixed(2)} KB`,
    },
    // {
    //   title: "Artist",
    //   dataIndex: "artist",
    //   key: "artist",
    //   editable: true,
    // },
    {
      title: "Artist",
      dataIndex: "artist",
      key: "artist",
      editable: true,
    },
    {
      title: "Track",
      dataIndex: "track",
      key: "track",
      editable: true,
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      editable: true,
    },
    {
      title: "Progress",
      dataIndex: "progress",
      key: "progress",
      render: (_, record: FileData) => {
        // console.log(FILE_UPLOAD_CONFIG);
        // // console.log("." + record.format == "mpeg" ? "mp3" : record.format);
        // const config =
        //   FILE_UPLOAD_CONFIG[
        //     "." + (record.format == "mpeg" ? "mp3" : record.format)
        //   ];
        // console.log("config", config);
        return (
          <>
            <Progress percent={record.progress} />
            {/* <Text>MP3 file processed via Alpha API</Text> */}
            {/* {config && (
              <Text style={{ fontSize: "smaller" }}>
                {record.format.replace(".", "").toUpperCase()} file processed
                via {config.endpoint}
              </Text>
            )} */}
          </>
        );
      },
    },
    // {
    //   title: "Action",
    //   dataIndex: "operation",
    //   render: (_, record: FileData) => {
    //     const editable = isEditing(record);
    //     return editable ? (
    //       <span>
    //         <Typography.Link
    //           onClick={() => save(record.key)}
    //           style={{ marginRight: 8 }}
    //         >
    //           Save
    //         </Typography.Link>
    //         <Typography.Link title="Sure to cancel?" onClick={cancel}>
    //           <a>Cancel</a>
    //         </Typography.Link>
    //       </span>
    //     ) : (

    //       <Button
    //         style={{ background: "none" }}
    //         type="text"
    //         disabled={editingKey !== ""}
    //         onClick={() => edit(record)}
    //         icon={<EditOutlined />}
    //         size="middle"
    //       />
    //     );
    //   },
    // },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: FileData) => ({
        record,
        dataIndex: col.dataIndex,
        title: col.title,

        editing: isEditing(record),
      }),
    };
  });
  // const mergedColumns = columns.map((col) => {
  //   if (!col.editable) {
  //     return col;
  //   }
  //   return {
  //     ...col,
  //     onCell: (record) => ({
  //       // Pass the record object here
  //       record,
  //       dataIndex: col.dataIndex,
  //       title: col.title,
  //     }),
  //   };
  // });

  // const EditableCell = ({ dataIndex, title, children, ...restProps }) => {
  //   const { record } = restProps; // Destructure the `record` from props
  //   console.log("recordd", record);
  //   return (
  //     <td {...restProps}>
  //       <Form.Item
  //         name={[record.key, dataIndex]} // The key fix is here
  //         style={{ margin: 0 }}
  //         rules={[{ required: true, message: `Please input ${title}!` }]}
  //       >
  //         <Input style={{ background: "#0B8DDC33" }} />
  //       </Form.Item>
  //     </td>
  //   );
  // };

  const EditableCell = ({
    record,
    dataIndex,
    title,
    children,
    ...restProps
  }) => {
    if (!record) {
      // This check prevents the TypeError for non-editable cells
      return <td {...restProps}>{children}</td>;
    }

    return (
      <td {...restProps}>
        <Form.Item
          name={[record.key, dataIndex]}
          style={{ margin: 0 }}
          rules={[{ required: true, message: `Please input ${title}!` }]}
        >
          <Input style={{ background: "#0B8DDC33" }} />
        </Form.Item>
      </td>
    );
  };
  // const EditableCell = ({
  //   editing,
  //   dataIndex,
  //   title,
  //   children,
  //   ...restProps
  // }) => {
  //   const inputNode = <Input style={{ background: "#0B8DDC33" }} />;

  //   return (
  //     <td {...restProps}>
  //       {editing ? (
  //         <Form.Item
  //           name={dataIndex}
  //           style={{ margin: 0 }}
  //           rules={[
  //             {
  //               required: true,
  //               message: `Please Input ${title}!`,
  //             },
  //           ]}
  //         >
  //           {inputNode}
  //         </Form.Item>
  //       ) : (
  //         children
  //       )}
  //     </td>
  //   );
  // };

  return (
    <Form
      form={form}
      component={false}
      // onValuesChange={debouncedOnValuesChange}
      style={{ background: "red" }}
    >
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        dataSource={fileList}
        columns={mergedColumns}
        // rowClassName="editable-row"
        rowClassName="custom-row"
        rowKey="key"
        pagination={false}
        scroll={{ y: 400 }}
      />
    </Form>
  );
};

export default EditableTable;
